export const moodTags = [
  { key: "all", label: "全部" },
  { key: "night", label: "深夜独处" },
  { key: "miss", label: "思念" },
  { key: "regret", label: "遗憾" },
  { key: "growth", label: "成长" },
  { key: "farewell", label: "告别" },
  { key: "gentle", label: "温柔治愈" },
];

export const featuredQuotes = [
  {
    id: "q1",
    text: "把想念调成静音，才发现它从没有真正停过，只是学会了不出声。",
    mood: "miss",
    scene: "适合深夜躺着发呆时读",
  },
  {
    id: "q2",
    text: "有些话适合烂在心里，长成一片没人路过的荒原。",
    mood: "night",
    scene: "写给睡不着的你",
  },
  {
    id: "q3",
    text: "我们都没有错，只是时间把我们摆在了不同的站点。",
    mood: "farewell",
    scene: "适合告别后的很长一段日子",
  },
  {
    id: "q4",
    text: "后来我把难过讲给风听，风替我哭了一整个下午。",
    mood: "regret",
    scene: "下雨天更配",
  },
  {
    id: "q5",
    text: "原来长大不是变得坚硬，而是学会在自己难过的时候，先给自己倒一杯热水。",
    mood: "growth",
    scene: "适合给自己打气的时候",
  },
  {
    id: "q6",
    text: "你看，长日光阴这么长，足够把一个人从眼泪里慢慢捞出来。",
    mood: "gentle",
    scene: "给正在慢慢好起来的你",
  },
  {
    id: "q7",
    text: "凌晨三点的清醒，是一天里最诚实的时刻，没人打扰，也骗不了自己。",
    mood: "night",
    scene: "深夜独处的共鸣",
  },
  {
    id: "q8",
    text: "我把你留在旧相册里，不是放不下，是舍不得那个认真喜欢过你的自己。",
    mood: "miss",
    scene: "适合翻旧照片时",
  },
  {
    id: "q9",
    text: "有些遗憾是被时间磨圆的，不再扎人，却永远在那里。",
    mood: "regret",
    scene: "给走不出来的那阵子",
  },
  {
    id: "q10",
    text: "我们终于学会了不吵不闹地走散，像两片被风吹往不同方向的云。",
    mood: "farewell",
    scene: "适合体面收场的关系",
  },
  {
    id: "q11",
    text: "不必急着好起来，允许自己慢慢来，日子会把伤口熬成一道浅浅的纹路。",
    mood: "gentle",
    scene: "适合情绪低落时读",
  },
  {
    id: "q12",
    text: "难过的时候别照镜子，那里的人比谁都更懂你的委屈。",
    mood: "growth",
    scene: "写给正在自我怀疑的人",
  },
  {
    id: "q13",
    text: "深夜最适合想那些白天不敢想的名字，想着想着，天就亮了。",
    mood: "night",
    scene: "深夜独处的共鸣",
  },
  {
    id: "q14",
    text: "思念是一封没有地址的信，写了很多遍，也不知道要寄给谁。",
    mood: "miss",
    scene: "适合收藏在心里",
  },
  {
    id: "q15",
    text: "时间没有治愈我，它只是教会我把伤口藏得更体面一点。",
    mood: "regret",
    scene: "给假装很好的你",
  },
  {
    id: "q16",
    text: "终有一天你会发现，那些让你彻夜难眠的事，都会变成睡前一句轻描淡写的「算了」。",
    mood: "growth",
    scene: "适合用来安慰自己",
  },
];

export const healingLines = [
  {
    id: "l1",
    text: "日落尤其温柔，人间皆是浪漫。",
    note: "适合傍晚在窗边发呆时看一眼。",
  },
  {
    id: "l2",
    text: "你已经很勇敢了，撑到现在的每个人都很了不起。",
    note: "写给正在硬撑的你。",
  },
  {
    id: "l3",
    text: "风会记住一朵花的香，时间会记得你的努力。",
    note: "适合疲惫的时候读。",
  },
  {
    id: "l4",
    text: "允许一切发生，也允许一切慢慢过去。",
    note: "情绪低落时的三秒安抚。",
  },
  {
    id: "l5",
    text: "难过可以，但别难过太久，世界还留着好多好天气给你。",
    note: "给容易想太多的你。",
  },
  {
    id: "l6",
    text: "今天的月亮也很努力，我们都要对自己温柔一点。",
    note: "深夜睡前的轻声提醒。",
  },
  {
    id: "l7",
    text: "生活不会一直对你笑，但它也从没真的放弃过你。",
    note: "适合用来重启心情。",
  },
  {
    id: "l8",
    text: "慢慢来，你又不差，只是还没走到属于你的那段光里。",
    note: "写给总觉得自己落后的人。",
  },
  {
    id: "l9",
    text: "把心事交给夜，把不安交给明天，今晚先好好睡觉。",
    note: "适合睡前默念。",
  },
];

export const timeReflections = [
  {
    id: "r1",
    period: "暮色",
    title: "关于「长日光阴」这四个字，我想说的其实是慢慢来",
    lead: "很多人以为伤感是一种沉溺，可在我这里，它更像一段被拉长的日光——不急，不吵，慢慢把人心里的褶皱熨平。",
    body: [
      "「长日光阴」不是一个具体的时刻，而是一种状态。它可能是午后三点的窗台，光斜斜地落在桌角，你捧着杯子，什么都不想做；也可能是凌晨的房间，只有手机屏幕一点微光，把心事照得清清楚楚。",
      "我们习惯把伤感藏起来，觉得那是不够坚强的证据。可其实，能在难过的日子里依然好好吃饭、好好上班、好好回一条消息，本身就已经是一种很了不起的坚持。",
      "长日光阴的意思，是告诉自己：这段时间是长的，长到足够你走完情绪的低谷，也长到足够你重新喜欢上晨光。你不必今天就好起来，你可以明天也好不起来，但请你别急着否定自己。",
    ],
  },
  {
    id: "r2",
    period: "深夜",
    title: "深夜为什么会放大情绪，又为什么它偶尔救人",
    lead: "白天我们用忙碌把感受压到最底下，到了夜里，安静把一切都还了回来。这不是矫情，只是人在没有防备的时候，最诚实。",
    body: [
      "心理学里常说，人在疲惫、安静、独处的时候，情绪调节能力会下降，于是那些白天被压住的难过会一起涌上来。所以深夜想哭并不代表你脆弱，它只是提醒你：白天你真的很用力在装着没事。",
      "但深夜也不全是坏的。很多想说的话、想通的道理、想放下的执着，都是在这样的时刻完成的。夜里掉过的眼泪，第二天常常会变成一种奇怪的轻松。",
      "如果现在的你也醒着，我想说：谢谢你今晚也坚持到了这里。天会亮的，而你现在要做的，可能只是躺着，等它亮。",
    ],
  },
  {
    id: "r3",
    period: "清晨",
    title: "写给凌晨掉过眼泪、第二天照常起床上班的你",
    lead: "有些人把难过过成了深夜的私事，天亮之后，还是那个把生活打理得井井有条的人。这份安静，比任何口号都动人。",
    body: [
      "我见过太多这样的人了：哭完洗把脸，第二天照样准时出现在地铁和会议室里，笑着接住每一句「早啊」。他们不是不难过，只是学会了把情绪收好，不让它影响到别人。",
      "可我还是希望，有一天你能不必那么懂事。能有人在你难过的时候递过来一杯温水，能有个地方让你把「我撑不住了」这句话原样讲出来。",
      "在那一天到来之前，愿你至少能对自己温柔一些。买杯喜欢的饮料，绕一点远路回家，允许自己偶尔摆烂。你已经做得很好了，真的。",
    ],
  },
  {
    id: "r4",
    period: "旧时光",
    title: "关于放下：不是删掉回忆，而是允许它不再影响你",
    lead: "很多人误会了放下的样子，以为那要轰轰烈烈地删人、拉黑、重新开始。其实真正的放下，往往安静得像一个普通的下午。",
    body: [
      "你还是会记起那个人，会记得某个夏天、某句话、某次没有说出口的挽留。但这些画面再来的时候，胸口不再发紧，只是轻轻地想：哦，原来发生过。",
      "放下不是失忆，也不是原谅谁，而是你终于把注意力重新放回了自己身上。你开始在意今天有没有吃到好吃的，开始为一件小事真的开心。",
      "如果此刻你还没有走到那一步，也没关系。我在这篇文字里替你留了个位置：慢慢来，长日光阴会替你收着一切。",
    ],
  },
];

export const sceneCompanions = [
  {
    id: "s1",
    time: "22:00 — 00:00",
    label: "睡前独处",
    title: "关掉灯之后，留一盏给心情",
    desc: "还没到最难过的时候，只是有点空。适合读一些轻的、暖的句子，让脑子先慢下来。",
    lines: [
      "今天没有做错什么，只是有一点累，允许自己早点休息。",
      "把手机放远一点，把心事放轻一点。",
      "明天的烦恼交给明天的你，今晚的我只负责睡觉。",
    ],
  },
  {
    id: "s2",
    time: "00:00 — 03:00",
    label: "深夜清醒",
    title: "这段最安静的清醒，也最需要被接住",
    desc: "情绪最浓的时刻，不适合硬撑。找几句和你此刻一样的话，让它们陪着你就好。",
    lines: [
      "凌晨的清醒里，没有人骗得了自己，所以更要对自己诚实一点。",
      "想一个人不丢人，想哭就哭，眼泪是身体替心倒的一杯水。",
      "现在睡不着的你，请记得：明天依然值得被期待。",
    ],
  },
  {
    id: "s3",
    time: "05:00 — 07:00",
    label: "将亮未亮",
    title: "天快亮了，也许就是那句话说的转机",
    desc: "熬夜的人总在这时候撑不住，也总在这时候被一点微光捞起来。读点向前看的文字。",
    lines: [
      "你看，天快亮了，昨晚那么难，你也还是走到了这里。",
      "太阳照常升起的意义，是提醒我们什么都可以重新开始。",
      "熬过去的人，才配得上更好的清晨。",
    ],
  },
  {
    id: "s4",
    time: "雨天 / 阴天",
    label: "阴雨陪伴",
    title: "下雨的时候，允许自己更软一点",
    desc: "雨天会放大情绪，也最适合让情绪好好流动。配一杯热饮，读几行顺著眼泪的文字。",
    lines: [
      "雨替你把话说了，所以你今天可以什么也不说。",
      "阴天不代表不好，只是天空也需要休息一下。",
      "听雨的时候，心会慢慢安静下来。",
    ],
  },
];

export const momentCaptions = [
  { id: "c1", text: "把情绪调成静音，是成年人最后的体面。", tone: "克制" },
  { id: "c2", text: "长日光阴，慢慢走，不着急。", tone: "温柔" },
  { id: "c3", text: "今天也有好好活着，虽然只是一点点。", tone: "自愈" },
  { id: "c4", text: "风太大了，把我想说的话都吹走了。", tone: "伤感" },
  { id: "c5", text: "我把难过存进了深夜，白天照常营业。", tone: "深夜" },
  { id: "c6", text: "有人来，有人走，而我学会了安静地站在原地。", tone: "释然" },
  { id: "c7", text: "慢慢来，会好的，这句话我对自己说了一百遍。", tone: "温柔" },
  { id: "c8", text: "如果快乐太难，那就先祝我们平安。", tone: "祝愿" },
  { id: "c9", text: "晚上睡个好觉，明天又是可以重新开始的一天。", tone: "自愈" },
];

export const resonancePosts = [
  {
    id: "p1",
    name: "凌晨的猫",
    text: "看到「把想念调成静音」那句，突然哭了。原来不止我一个人这样。",
    likes: 128,
    date: "10 月 3 日",
  },
  {
    id: "p2",
    name: "西二环的雨",
    text: "加班到十一点，地铁上读完整个页面，居然没那么想哭了，谢谢。",
    likes: 96,
    date: "10 月 4 日",
  },
  {
    id: "p3",
    name: "阿禾",
    text: "收藏了「写给凌晨掉过眼泪、第二天照常起床上班的你」，像有人在跟我说辛苦了。",
    likes: 211,
    date: "10 月 5 日",
  },
  {
    id: "p4",
    name: "一杯温水",
    text: "分手三个月，今天终于把这句话看懂了：放下不是删掉回忆，而是它不再影响你。",
    likes: 174,
    date: "10 月 6 日",
  },
  {
    id: "p5",
    name: "眠",
    text: "深夜独处这个场景简直是为我写的，22 点到 3 点，我全都在。",
    likes: 88,
    date: "10 月 7 日",
  },
  {
    id: "p6",
    name: "南风知我意",
    text: "「允许一切发生，也允许一切慢慢过去」，写在手机备忘录里了。",
    likes: 143,
    date: "10 月 8 日",
  },
];

export const faqs = [
  {
    q: "「长日光阴」的伤感文案适合什么场合使用？",
    a: "它们更偏向情绪表达，适合深夜独处时自我安抚、写在备忘录里、作为朋友圈或微博的文艺配文，也可以抄进手账当作一段心情记录。不建议用在正式的工作或对外场合。",
  },
  {
    q: "为什么这里的文字读起来不那么「丧」？",
    a: "本站的定位是用温柔克制的文字表达伤感，而不是放大难过。伤感被看见之后，本来就该慢慢变轻，所以我们会在很多句子里留一个往前的出口。",
  },
  {
    q: "页面的短句可以复制去发朋友圈吗？",
    a: "可以。治愈系短句和朋友圈配文区域都有一键复制按钮，点一下就能拿走，直接粘到你想发的地方即可，无需注册或登录。",
  },
  {
    q: "心情标签筛选是怎么工作的？",
    a: "在精选语录区域点击顶部的标签，页面会即时过滤出对应心情的句子，比如「思念」「遗憾」「温柔治愈」。筛选只作用于本站已有的内容，不会发起任何网络请求。",
  },
  {
    q: "我情绪真的很低落，读这些会有帮助吗？",
    a: "被理解的感觉有时能让人松一口气，但文字不能替代真实的支持。如果你长期失眠、持续低落或出现伤害自己的念头，请务必联系信任的人或专业心理援助机构，你值得被认真对待。",
  },
  {
    q: "内容会更新吗？",
    a: "本站内容按心情与场景持续整理，目前的语录、短句与时光感悟都集中在同一页，方便你一次读完，也方便日后再回来翻看。",
  },
];